<template>
  <footer class="mt-5 mt-md-7 mt-lg-8">
    <div class="position-relative shell-footer">
      <div class="position-relative">
        <v-container class="py-6">
          <div
            class="
              justify-center justify-sm-space-around justify-md-space-between
              grid-list
            "
          >
            <div class="grid-list-item mt-auto">
              <router-link to="/">
                <img
                  src="../../assets/img/portalnobres.png"
                  height="100px"
                  class="d-block mx-auto mx-md-0 filter-white"
                />
              </router-link>

              <div class="text-center mt-5 mb-10">
                <ButtonWidget to="/contato"> Fale Conosco </ButtonWidget>
              </div>
            </div>

            <v-sheet
              v-if="smAndDown"
              width="100%"
              color="transparent"
              class="d-flex justify-center grid-list-item"
            >
              <v-btn
                class="text-body-2 text-none"
                to="/institucional"
                color="white"
                text
              >
                Agência de Turismo
              </v-btn>

              <v-btn
                class="text-body-2 text-none"
                to="/servicos"
                color="white"
                text
              >
                Serviços
              </v-btn>

              <v-btn
                class="text-body-2 text-none"
                to="/a-cidade"
                color="white"
                text
              >
                A Cidade
              </v-btn>
            </v-sheet>

            <div class="d-flex flex-column align-md-center grid-list-item">
              <v-sheet
                v-if="!smAndDown"
                width="100%"
                color="transparent"
                class="d-flex justify-center"
              >
                <v-btn
                  class="text-body-2 text-none"
                  to="/a-cidade"
                  color="white"
                  text
                >
                  A Cidade
                </v-btn>

                <v-btn
                  class="text-body-2 text-none"
                  to="/institucional"
                  color="white"
                  text
                >
                  A Agência
                </v-btn>

                <v-btn
                  class="text-body-2 text-none"
                  to="/servicos"
                  color="white"
                  text
                >
                  Serviços
                </v-btn>
              </v-sheet>

              <div class="d-flex align-center flex-column mt-5">
                <div
                  v-if="informations.attendance.length"
                  class="text-center mt-5"
                >
                  <div class="white--text text-body-2 font-weight-bold">
                    Atendimento
                  </div>

                  <div
                    class="white--text text-body-2 font-italic mt-1"
                    v-for="(item, keyAttendance) in informations.attendance"
                    :key="keyAttendance"
                  >
                    {{ item }}
                  </div>
                </div>

                <div
                  v-if="informations.whatsapp.length"
                  class="text-center mt-5"
                >
                  <div class="white--text text-body-2 font-weight-bold">
                    WhatsApp
                  </div>

                  <div class="justify-center text-center grid-whatsapp">
                    <div
                      class="text-body-2 font-italic mt-1 grid-whatsapp-item"
                      v-for="(item, keyWhatsapp) in informations.whatsapp"
                      :key="keyWhatsapp"
                    >
                      <a
                        class="white--text text-decoration-none"
                        :href="getWhatsappLinkFromPhone(item)"
                        target="_blank"
                      >
                        {{ item }}
                      </a>
                      <span
                        v-if="
                          keyWhatsapp % 2 === 0 &&
                          keyWhatsapp < informations.whatsapp.length - 1
                        "
                        class="white--text ml-1 mr-2"
                      >
                        |
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  v-if="informations.address.length"
                  class="text-center mt-5"
                >
                  <div class="white--text text-body-2 font-weight-bold">
                    Endereço
                  </div>

                  <div
                    class="white--text text-body-2 font-italic mt-1"
                    v-for="(item, keyAddress) in informations.address"
                    :key="keyAddress"
                  >
                    <a
                      v-if="informations.google_maps"
                      class="white--text text-decoration-none"
                      :href="informations.google_maps"
                      target="_blank"
                    >
                      {{ item }}
                    </a>
                    <span v-else>
                      {{ item }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <v-sheet
              class="d-flex flex-column align-center grid-item"
              color="transparent"
              height="100%"
            >
              <div
                class="d-flex align-center mt-auto"
                :class="{ 'mb-auto': !paymentMethods.length }"
              >
                <div
                  v-for="({ text, link, icon }, keySocial) in social"
                  :key="keySocial"
                  class="d-inline-flex ml-1"
                >
                  <v-btn
                    :href="link"
                    target="_blank"
                    min-width="auto"
                    color="transparent"
                    :title="text"
                    depressed
                    rounded
                    fab
                  >
                    <v-icon color="white" size="26">{{ icon }}</v-icon>
                  </v-btn>
                </div>
              </div>

              <div class="d-flex flex-column mt-4 mt-sm-auto">
                <div
                  class="white--text text-body-1 text-center font-weight-bold"
                >
                  Formas de Pagamento
                </div>

                <div class="d-flex flex-wrap justify-center align-center mt-4">
                  <div
                    class="ml-1 mb-1"
                    v-for="(item, keyPayment) in paymentMethods"
                    :key="keyPayment"
                  >
                    <img
                      class="d-block rounded-pill img-payment-method"
                      :src="files + item + '?resize=1&w=52'"
                      width="52"
                      height="52"
                    />
                  </div>
                </div>
              </div>
            </v-sheet>
          </div>
        </v-container>
      </div>
    </div>

    <v-sheet color="#0e1218">
      <v-container
        class="
          pt-0
          pb-5
          d-flex
          flex-column flex-sm-row
          justify-space-between
          align-center
          text-center
        "
      >
        <div class="white--text text-caption mt-5">
          Copyright ©
          <b class="font-weight-bold">
            {{ year }} {{ informations.short_name }}.
          </b>
          <span class="d-block d-sm-inline-block">
            Todos os direitos reservados.
          </span>
        </div>
        <a
          class="d-flex mt-5"
          href="https://www.mrxweb.com.br/"
          target="_blank"
        >
          <img
            class="shell-footer-logo"
            src="../../assets/img/mrxweb.svg"
            alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            height="20px"
          />
        </a>
      </v-container>
    </v-sheet>
  </footer>
</template>

<script>
import ButtonWidget from "../widgets/ButtonWidget.vue";
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";
import { getContact } from "../../utils/getContact";
import { getSocial } from "../../utils/getSocial";

export default {
  data: () => ({
    year: new Date().getFullYear(),
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    contacts() {
      return getContact(this.informations);
    },
    social() {
      return getSocial(this.informations);
    },
    paymentMethods() {
      if (
        !this.informations.payment_methods ||
        (!this.informations.payment_methods.list &&
          !this.informations.payment_methods.length)
      )
        return [];

      return this.informations.payment_methods.list.map(({ path }) => {
        return path;
      });
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getWhatsappLinkFromPhone,
  },
  components: {
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.shell-footer {
  background-attachment: fixed;
  background-image: url(../../assets/img/bg-footer.webp) !important;
  background-position: 50% 0;
  background-size: cover;
  background-repeat: no-repeat;

  &:before {
    background-color: rgba(3, 31, 65, 0.71);
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }

  .grid-whatsapp {
    display: grid;
    grid-template-columns: auto auto;

    &-item {
      white-space: nowrap;
    }
  }

  .grid-list {
    display: grid;
    gap: 24px 48px;
    grid-template-columns: auto 1fr auto;

    @media screen and (min-width: 600.001px) and (max-width: 960px) {
      gap: 24px;
      grid-template-columns: auto auto;

      &-item:first-child,
      &-item:nth-child(2) {
        grid-column-start: 1;
        grid-column-end: 3;
      }
    }

    @media screen and (max-width: 600px) {
      grid-template-columns: 1fr;
    }

    .btn-contact::v-deep {
      .v-btn__content {
        max-width: 100%;
        white-space: normal;
      }
    }
  }
}

.img-payment-method {
  -o-object-fit: contain;
  object-fit: contain;
  pointer-events: none;
}
</style>
